import { ChatBody, ChatHeader } from "../../components";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function AdminChatWindow(props) {
  // admin chat window with a header, body, and minimize/maximize button, showing an unread messages indicator when there are new messages in the chat

  const { unreadMessages } = useSelector((state) => state.user);

  return (
    <div>
    {/* new message indicator */}
      {unreadMessages && unreadMessages[props?.sessionId] && (
        <span className="position-absolute top-1 start-0 translate-middle p-2 bg-danger border border-light rounded-circle"></span>
      )}
      <ChatHeader
        admin={true}
        text={`Chat With ${props?.chatData?.userName || "User"}`}
      />
      <ChatBody
        isAdmin={true}
        chatHistory={props?.chatData?.chatHistory}
        minimized={props?.minimizedChats.find(
          (item) => item === props.sessionId
        )}
        submitChatMsg={props.submitChatMsg}
        handleEndChat={props?.handleEndChat}
        sessionId={props.sessionId}
        handleTyping={props?.handleTyping}
        partnerIsTyping={props?.partnerIsTyping}
        chatErrorMsg={props.chatErrorMsg}
      />
      <div
        style={{
          position: "absolute",
          right: "0",
          top: "0",
          zIndex: "2",
        }}
      >
        <Button
          className="btn-lg"
          variant="none"
          type="button"
          style={{ color: "white" }}
          onClick={() => {
            props.minimizedChats.find((item) => item === props.sessionId)
              ? props.handleMaximizeChat(props.sessionId)
              : props.handleMinimizeChat(props.sessionId);
          }}
        >
          {!props.minimizedChats.find((item) => item === props.sessionId) ? (
            <i className="bi bi-dash"></i>
          ) : (
            <i className="bi bi-app"></i>
          )}
        </Button>
      </div>
    </div>
  );
}
